import {z} from 'zod'

import type {AuthUser} from './types'

export const userResponseSchema = z
    .object({
        id: z.string(),
        name: z.string(),
        email: z.string(),
        role: z.enum(['admin', 'manager', 'member']),
        dispatch_yard_id: z.string().nullable().default(null),
        is_sales_rep: z.boolean().default(false),
    })
    .transform(
        (raw): AuthUser => ({
            id: raw.id,
            name: raw.name,
            email: raw.email,
            role: raw.role,
            dispatchYardId: raw.dispatch_yard_id,
            isSalesRep: raw.is_sales_rep,
        }),
    )

const emailSentLoginResponseSchema = z.object({
    status: z.literal('email_sent'),
    from_email: z.string(),
})

const notRegisteredLoginResponseSchema = z.object({
    status: z.literal('not_registered'),
})

/** Schema for `POST /auth/login` responses. */
export const loginResponseSchema = z.discriminatedUnion('status', [
    emailSentLoginResponseSchema,
    notRegisteredLoginResponseSchema,
])

export type LoginResponse = z.infer<typeof loginResponseSchema>
